<template>
  <el-config-provider :locale="elementPlusLocale">
    <Header />



    <div class="container-fluid">
      <div class="row" style="height: calc(100vh - 3.75rem)">
        <div
          v-if="!['/payment', '/submit_order', '/payment-success'].includes(route.path)"
          class="col-2 w-100-sm sidebar-container"
          style="border-right: 1px solid #dadada"
        >
          <!-- Sidebar -->
          <nav id="sidebarMenu" class="bg-white">
            <div class="position-sticky">
              <CustomRouter></CustomRouter>
            </div>
          </nav>
          <!-- Sidebar -->
        </div>

        <div
          class="col-10 w-100-sm content-container"
          :class="[
            !['/payment', '/submit_order', '/payment-success'].includes(route.path)
              ? 'col-10 p-0-sm'
              : 'col-12 p-0-sm'
          ]"
          style="background-color: #f0f6ff"
          :style="{
            padding: !['/payment', '/submit_order', '/payment-success'].includes(route.path)
              ? '2rem 1.5rem'
              : '1.5rem 8.68rem'
          }"
        >
          <router-view></router-view>
        </div>
      </div>
    </div>
  </el-config-provider>
</template>

<script setup>
import CustomRouter from './router/index.vue'
import Header from './components/common/Header.vue'
import { useRoute } from 'vue-router'
import { watchEffect, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getElementPlusLocale } from '../lang'
const route = useRoute()
import i18n from '../lang'

const { locale } = useI18n()

const elementPlusLocale = computed(() => {
  return getElementPlusLocale(locale.value)
})

watchEffect(() => {
  if (route.meta && route.meta.title) {
    document.title = i18n.global.t(route.meta.title)
  }
})
</script>

<style>
.sidebar-container {
  overflow-y: auto;
  height: 100%;
}
.content-container {
  overflow-y: auto;
  height: 100%;
}

@media (max-width: 744px) {
  .row {
    overflow-y: scroll;
    height: calc(100vh - 3.75rem) !important;
  }
  .sidebar-container,
  .content-container {
    overflow-y: visible;
    height: auto;
  }
}
</style>
